<template>
    <div class="cohort-scroll">
        <table class="cohort-table">
            <thead>
                <tr>
                    <th class="cohort-head">{{ $t('business.cohort') }}</th>
                    <th class="cohort-head">{{ $t('business.cohort_size') }}</th>
                    <th v-for="mark in marks" :key="mark" class="cohort-head">{{ mark }}m</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in items" :key="row.period">
                    <td class="cohort-label">{{ row.label }}</td>
                    <td class="cohort-total">{{ row.total }}</td>
                    <td v-for="(value, index) in row.values" :key="index" class="cohort-cell"
                        :style="cellStyle(value)">
                        {{ value === null ? '' : `${value}%` }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
const FILLED = [
    { min: 100, dark: 0.9, light: 0.85 },
    { min: 70, dark: 0.7, light: 0.65 },
    { min: 40, dark: 0.5, light: 0.45 },
    { min: 20, dark: 0.3, light: 0.28 },
    { min: 1, dark: 0.15, light: 0.12 },
]

export default {
    name: "CohortTable",
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        marks(vm = this) {
            const length = vm.rows[0]?.values?.length || 12
            return Array.from({ length }, (item, i) => i + 1)
        },
        items(vm = this) {
            void vm.$i18n.locale
            return vm.rows.map(row => {
                const date = vm.$moment(row.period, 'YYYY-MM')
                return { ...row, label: `${date.format('MMM').replace('.', '')} '${date.format('YY')}` }
            })
        },
    },
    methods: {
        cellStyle(value) {
            const vm = this
            const dark = vm.$vuetify.theme.dark
            if (value === null) return { background: 'transparent' }
            if (value === 0) {
                return {
                    background: dark ? 'rgba(42, 52, 80, 0.6)' : 'rgba(200, 210, 220, 0.5)',
                    color: 'var(--v-txtMuted-base)',
                }
            }

            const step = FILLED.find(item => value >= item.min) || FILLED[FILLED.length - 1]
            const rgb = dark ? '102, 204, 204' : '51, 153, 153'
            return {
                background: `rgba(${rgb}, ${dark ? step.dark : step.light})`,
                color: value >= 40 ? '#0C0E12' : 'var(--v-txtSecondary-base)',
            }
        },
    },
}
</script>

<style scoped>
.cohort-scroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
}

.cohort-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 2px;
}

.cohort-head {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 4px 5px;
    background: var(--v-surface-base);
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--v-txtMuted-base);
    white-space: nowrap;
}

.cohort-label {
    padding: 4px 6px;
    font-size: 10px;
    font-weight: 700;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
}

.cohort-total {
    padding: 4px 6px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    color: var(--v-txtMuted-base);
}

.cohort-cell {
    padding: 4px 5px;
    min-width: 34px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
}
</style>
